// extracted by mini-css-extract-plugin
module.exports = {"marqueeSlider":"vue-marquee-slider_marqueeSlider_18cmt","marqueeSliderContainer":"vue-marquee-slider_marqueeSliderContainer_GxyCV","animation":"vue-marquee-slider_animation_2BlMb"};